import React from "react";
import About from "../About/About";
import Address from "../Address/Address";
import Banner from "../Banner/Banner";
import Products from "../Products/Products";
import Services from "../Services/Services";
import Team from "../Team/Team";
import Testimonial from "../Testimonial/Testimonial";
// import Team2 from '../Team2/Team2';
import WhyUs from "../WhyUs/WhyUs"
import StoreMap from "../StoreMap/StoreMap";
import CorporateClients from "../CorporateClients/CorporateClients";

const Home = () => {
  return (
    <div className="mx-2 md:mx-1 sm:mx-2">
      <Banner />
      <About />
      <Services />
      <Address />
      <Products />
      <CorporateClients/>
      <WhyUs />
      <StoreMap/>
      <Team />
      <Testimonial />
      {/* <Team/> */}
      {/* <Team2/> */}
    </div>
  );
};

export default Home;
